import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Loading } from '../../../shared/components/Loading';
import {
  analysisTypeSelector,
  errorTypeSelector,
  recordTypeSelector,
} from '../selectors/ecg.selectors';
import { cleanUp } from '../thunks/clean-up.thunk';
import { loadData } from '../thunks/load-data.thunk';
import { isEcgAlreadyProcessed } from '../utils/ecg.utils';
import { Reprocessor } from './Reprocessor';
import { Text } from '@cdl/heartbeat-react';

export interface Props {
  ecgId: string;
}

export const Loader: React.FC<Props> = ({ ecgId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const analysisType = useSelector(analysisTypeSelector);
  const recordType = useSelector(recordTypeSelector);
  const errorType = useSelector(errorTypeSelector);
  const [errored, setErrored] = useState(false);
  useEffect(() => {
    let reRendered = false;
    (async () => {
      try {
        await dispatch(loadData(ecgId));
      } catch {
        if (!reRendered) {
          setErrored(true);
        }
      }
    })();
    return () => {
      reRendered = true;
    };
  }, [ecgId, dispatch]);

  if (!isEcgAlreadyProcessed(analysisType)) {
    if (recordType !== 'holter') {
      if (errorType === 'processing_error') {
        dispatch(cleanUp());
        navigate('/');
      }
      return <Reprocessor ecgId={ecgId} />;
    } else {
      return <Text m='m'>This ecg cannot be viewed inside Platane</Text>;
    }
  }

  if (errored) {
    return (
      <Text m='m'>
        This id is invalid or the requested ecg is not in your datasets
      </Text>
    );
  }

  return <Loading>Loading ecg data...</Loading>;
};
